import { Component, HostListener, OnInit } from '@angular/core';
import { BaseService, SettingsService, StorageService } from '../services';
import { Router } from '@angular/router';
import { ConfigurationService } from '../services/configuration.service';
import { CategoriesService } from '../services/categories.service';
import { ContentService } from '../services/content.service';
import { environment } from 'src/environment';
import { LoggerService } from '../authentication/logger.service';
import { FooterService } from 'src/app/core/services/footer.service';
import { InhouseAnalyticsService } from '../services/inhouse-analytics.service';
import { ApplicationService } from '../services/application.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  selectedLocale: any;
  selectedLocaleKey: any;
  locales: any;
  localeLength: any;
  showLanguageTop = true;
  dropPosBottom = true;
  prevHeight: number;
  isMobile: boolean;
  innerWidth;
  feedbackEnabled;
  restrictedUser;
  skinName = environment.skinName;
  appName;
  informationPages: any;
  helpPages: any;
  constructor(public configService:ConfigurationService, private applicationService:ApplicationService, private storageService:StorageService,
              public settingsService: SettingsService, public categoryService: CategoriesService,
              public baseService: BaseService, private router: Router, private contentService: ContentService,
              private loggerService: LoggerService, private footerService:FooterService, private analyticsService: InhouseAnalyticsService ) {
    this.appName = environment.apiAppName;
    this.selectedLocaleKey = this.configService.locales[this.configService.localeIndex].lang_code;
    this.locales = this.configService.locales;
    this.localeLength = this.locales.length;
    this.feedbackEnabled = this.settingsService.feedbackEnabled;
    if (this.localeLength <6) this.dropPosBottom = false;
    this.checkLangPostion();
    this.prevHeight = window.innerHeight;
    this.innerWidth = window.innerWidth;
    this.isMobile = this.baseService.isMobileOrNot();
    this.restrictedUser = environment.isEzProxy || (this.storageService.getLocalStore('hoopla_user') == '1') ? true :false;
    this.filterPages();
  }
  async ngOnInit() {
    await this.applicationService.translateSelectedLocale().then((selectedLocale) =>  {
      this.selectedLocale = selectedLocale;
    });
    this.locales = this.applicationService.translateLanguage(this.locales);
    this.loggerService.hooplaUser.subscribe(data => {
      if (data === true) this.restrictedUser = true;
    });
  }

  filterPages() {
    this.informationPages = this.footerService.pageList.filter((item: any) => {
      return item.type !== 'faq' && item.type !== 'contact';
    });
    this.helpPages = this.footerService.pageList.filter((item: any) => {
      return item.type === 'faq' || item.type === 'contact';
    });
  }

  setLocale(i, value) {
    const eventObj = {
      event_type: 'Event',
      event_name: 'Language Selection',
      event_status: 'Success',
      event_description: `Selected Language - ${this.selectedLocaleKey}`,
    };
    this.analyticsService.trackUserActions(eventObj);
    this.selectedLocale = value.translatedLanguage;
    this.selectedLocaleKey = value.lang_code;
    this.configService.localeIndex = i;
    this.storageService.setLocalStore('locale', this.selectedLocaleKey);
    this.storageService.setLocalStore('localeName', this.selectedLocale);
    this.configService.setlocaleCookie(this.selectedLocaleKey);
    this.configService.locale = this.selectedLocaleKey;
    window.location.reload();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkLangPostion();
    this.innerWidth = window.innerWidth;
    this.isMobile = this.baseService.isMobileOrNot();
  }

  checkLangPostion(){
    if(window.innerWidth< 560) this.showLanguageTop = false;
    else this.showLanguageTop = true;
  }
// this method redirct to feedback componet.
  feedbackRedirect() {
    let feedbackURL = '/app/feedback';
    this.router.navigateByUrl(feedbackURL)
  }

  redirect(value) {
    window.scrollTo({top: 0,behavior: 'smooth'});
    this.baseService.newCategoryRedirection(value);
  }

  sendMatomoEvent(buttonType) {
    const eventObj = {
      event_type: 'Event',
      event_name: `${buttonType} button click`,
      event_status: 'Success'
    };
    this.analyticsService.trackUserActions(eventObj);
  }

}
